import { Abstrap } from '..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class Notification extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-notification',
            className,
        ];
    }

}

Notification.propTypes = propTypes;

Notification.defaultProps = defaultProps;

export default Notification;
